import React from 'react'
import DeliveredPhotos from 'components/shared/DeliveredPhotos'
import {shouldShowDeliveredPhotos, productIsDelivered} from 'lib/productHelpers'
import DefaultProductStatus from '../../DefaultProductStatus'

const AiStudioPhotoEditingProduct = ({match, product, viewer}) => {
  if (shouldShowDeliveredPhotos(product)) {
    const photoOrder = viewer.photoOrderPreference.edges.map(edge => edge.node.name)
    const isDelivered = productIsDelivered(product)
    return (
      <DeliveredPhotos
        estateId={match.params.estateId}
        product={product}
        photoOrder={photoOrder}
        canCreateCorrections={isDelivered && viewer.customer.canCreateCorrections}
        customProfiles={isDelivered && viewer.customer.customProfiles}
      />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

export default AiStudioPhotoEditingProduct
